export const HOME = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const VIDEO_CALL = '/videocall';
export const RESET_PASSWORD = '/resetpassword';
export const DOCUMENT = '/document';
export const MY_CLIENTS = '/clients';
export const CALENDAR = '/calendar';
export const THREE_D_HOMES = '/3dhomes';
export const SITEPLAN = '/siteplan';
export const DOC = '/doc';
export const DOC_CLIENT = '/doc-client';
export const PROFILE = '/profile/:uid';
export const FILE_EXPLORER = '/fileexplorer';
export const FINANCE = '/finance';
export const BOX_MATRIX = '/box-matrix';
export const BOOK_APPOINTMENT = '/book-appointment';
